<template>
	<div id="advantage">
		<div banner>
			<div class="container">
				<div>服务优势</div>
			</div>
		</div>
		<div class="container">
			<div left>
				<div>服务优势</div>
				<div category v-for="(item,index) in categories" :key="index" :open="open == item.id">
					<h5 @click="open = item.id">{{item.text}}</h5>
					<ul v-if="array && array[item.id]">
						<li
							v-for="(child, index2) in array[item.id]"
							@click="id = child.id"
							:key="index2"
						>{{child.title}}</li>
					</ul>
				</div>
			</div>
			<div detail>
				<h1>{{title}}</h1>
				<!--<div content v-html="article.content"></div>-->
				<div content>
					<v1 v-if="id == 1" />
					<v2 v-if="id == 2" />
					<v3 v-if="id == 3" />
					<v4 v-if="id == 4" />
					<v5 v-if="id == 5" />
					<v7 v-if="id == 7" />
					<v8 v-if="id == 8" />
					<v9 v-if="id == 9" />
					<v10 v-if="id == 10" />
					<v11 v-if="id == 11" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {
			v1: () => import('./article/list/1'),
			v2: () => import('./article/list/2'),
			v3: () => import('./article/list/3'),
			v4: () => import('./article/list/4'),
			v5: () => import('./article/list/5'),
			v7: () => import('./article/list/7'),
			v8: () => import('./article/list/8'),
			v9: () => import('./article/list/9'),
			v10: () => import('./article/list/10'),
			v11: () => import('./article/list/11'),
		},
		data() {
			return {
				categories: [],
				open: null,
				array: {
					10: null,
					20: null,
				},
				article: {},
				id: 1,
			};
		},
		computed: {
			title() {
				const $this = this;
				var title = null;
				for (var i in this.array) {
					if (this.array[i]) {
						this.array[i].map(function (a) {
							if (a.id == $this.id) {
								title = a.title;
							}
						});
					}
				}
				return title;
			}
		},
		watch: {
			open: {
				deep: true,
				handler(value) {
					this.fetchList(value);
				}
			}
		},
		mounted() {
			this.fetchCategories();
		},
		methods: {
			fetchCategories() {
				this.categories = [
					{
						"id": 10,
						"text": "IPO及再融资咨询"
					},
					{
						"id": 20,
						"text": "IPO前咨询管理"
					}
				];
				this.open = 10;
				return;
				const $this = this;
				this.$util.axios.get(this.$util.apiUrl('/article/categories/service'), null, function (data) {
					$this.categories = data;
					$this.open = 10;
				});
			},
			fetchList(id) {
				if (this.array[id]) {
					return;
				}
				const $this = this;
				if (id == 10) {
					$this.array[10] = [
						{
							"id": 1,
							"title": "IPO及再融资细分市场研究"
						},
						{
							"id": 2,
							"title": "IPO及再融资募投可研"
						},
						{
							"id": 3,
							"title": "IPO可行性分析和规划"
						},
						{
							"id": 4,
							"title": "IPO财务顾问"
						},
						{
							"id": 5,
							"title": "新三板市场申报"
						}
					];
				} else if (id == 20) {
					$this.array[20] = [
						{
							"id": 7,
							"title": "发展战略规划"
						},
						{
							"id": 8,
							"title": "人力资源管理"
						},
						{
							"id": 9,
							"title": "供应链管理"
						},
						{
							"id": 10,
							"title": "营销战略制定与实施"
						},
						{
							"id": 11,
							"title": "财务制度规范"
						}
					];
				}
				$this.fetchArticle(1);
				return;
				this.$util.axios.get(this.$util.apiUrl('/article/list/' + id), {
					title: true,
				}, function (data) {
					$this.array[id] = data;
					if (id == 10) {
						//$this.fetchArticle(data[0].id);
					}
				});
			},
			fetchArticle(id) {
				const $this = this;
				this.$util.axios.get(this.$util.apiUrl('/article/' + id), {
					title: true,
				}, function (data) {
					$this.article = data;
				});
			}
		}
	}
</script>
